import { useTranslation } from 'hooks';
import { IconCertificateLine, IconSettingsCheck } from 'components/icons';
import { isEmpty, map } from 'lodash';
import { DetailPageContext } from 'pages/[ket-qua-tim-kiem]/[chi-tiet-tin-rao]';
import { useContext } from 'react';

const ListSection = () => {
  const { realEstate } = useContext(DetailPageContext).pageData ?? {};
  const { fixedUtilities, utilities, localUtilities, villaView, equipmentsAndServices, legals } =
    realEstate ?? {};
  const translation = useTranslation();
  const utilityLists = [
    {
      label: 'Tiện ích cố định',
      content: map(
        fixedUtilities,
        (fixedUtility) => (translation.major.fixedUtilities as any)[fixedUtility],
      ),
    },
    {
      label: 'Tiện ích',
      content: map(utilities, (utility) => (translation.major.utilities as any)[utility]),
    },
    {
      label: 'Tiện ích trong khu vực',
      content: map(
        localUtilities,
        (localUtility) => (translation.major.localUtilities as any)[localUtility],
      ),
    },
    {
      label: 'View',
      content: map(villaView, (view) => (translation.major.villaViewTypes as any)[view]),
    },
    {
      label: 'Thiết bị, dịch vụ',
      content: map(
        equipmentsAndServices,
        (equipmentAndService) =>
          (translation.major.equipmentsAndServices as any)[equipmentAndService],
      ),
    },
  ];

  return !isEmpty(fixedUtilities) ||
    !isEmpty(utilities) ||
    !isEmpty(localUtilities) ||
    !isEmpty(villaView) ||
    !isEmpty(equipmentsAndServices) ||
    !isEmpty(legals) ? (
    <div id='list-section' className='flex flex-col space-y-[32px]'>
      {(!isEmpty(fixedUtilities) ||
        !isEmpty(utilities) ||
        !isEmpty(localUtilities) ||
        !isEmpty(villaView) ||
        !isEmpty(equipmentsAndServices)) && (
        <div className='flex flex-col space-y-[16px]'>
          <div className='flex items-center space-x-[10px]'>
            <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
              <IconSettingsCheck className='h-[18px] w-[18px]' />
            </div>
            <h2 className='text-[18px] font-[600] leading-[23px]'>Tiện ích</h2>
          </div>
          <div className='flex flex-col space-y-[15px]'>
            {map(
              utilityLists,
              (utilityList, utilityListIndex) =>
                !isEmpty(utilityList.content) && (
                  <div key={utilityListIndex} className='flex flex-col space-y-[15px] px-[16px]'>
                    <span className='font-[600]'>{utilityList.label}</span>
                    <div className='m-[-2px] flex flex-wrap'>
                      {map(utilityList.content, (utility, utilityIndex) => (
                        <div key={utilityIndex} className='p-[2px]'>
                          <div className='rounded-[150px] bg-background px-[10px] py-[5px] '>
                            <span className='leading-[23px]'>{utility}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ),
            )}
          </div>
        </div>
      )}
      {!isEmpty(legals) && (
        <div className='flex flex-col space-y-[16px]'>
          <div className='flex items-center space-x-[10px]'>
            <div className='flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-background'>
              <IconCertificateLine className='h-[18px] w-[18px]' />
            </div>
            <h2 className='text-[18px] font-[600] leading-[23px]'>Pháp lý</h2>
          </div>
          <div className='m-[-2px] flex flex-wrap px-[16px]'>
            {map(legals, (legal, legalIndex) => (
              <div key={legalIndex} className='p-[2px]'>
                <div className='rounded-[150px] bg-background px-[10px] py-[5px] '>
                  <span className='leading-[23px]'>{(translation.major.legals as any)[legal]}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : null;
};

export default ListSection;
